import { useEffect, useState } from 'react';
import { compareStates, getPartialState } from '../helpers/hooks/state';
import { defaultEqual } from '../helpers/compare';
export const usePartialState = (store, properties, equal = defaultEqual) => {
    const [state, setState] = useState(getPartialState(store.getInitialState(), properties));
    useEffect(() => {
        const subscription = store.subscribe((storeState) => {
            if (compareStates(state, storeState, properties, equal)) {
                setState(getPartialState(storeState, properties));
            }
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [state]);
    return state;
};
